'use client';

import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { useState } from 'react';
import { type GoalOption, TRK_LOCATION } from '../../../../config';
import { FlowCta } from '../../../FlowCta';
import { GoalSelect } from './GoalSelect';
import { Title } from './Title';
export function GoalSelection() {
  const $ = _c(11);
  const [selectedOption, setSelectedOption] = useState("");
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = css({
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      bg: "common.white",
      rounded: "sm",
      mt: "2",
      mb: "3",
      boxShadow: "[0 1px 3px 0 rgb(0 0 0 / 0.12), 0 1px 2px 0 rgb(0 0 0 / 0.24)]",
      w: "[100%]",
      sm: {
        w: "[80%]"
      },
      maxW: "[550px]"
    });
    t1 = <Title />;
    t2 = css({
      display: "flex",
      px: {
        base: "2",
        md: "3"
      },
      py: "3.5",
      w: "[100%]",
      flexDirection: {
        base: "column",
        md: "row"
      },
      alignItems: "stretch",
      gap: "2"
    });
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== selectedOption) {
    t3 = <GoalSelect selectedOption={selectedOption} setSelectedOption={setSelectedOption} />;
    $[3] = selectedOption;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = css({
      md: {
        maxW: "[8rem]"
      }
    });
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== selectedOption) {
    t5 = <FlowCta primaryGoal={selectedOption} trkLocation={TRK_LOCATION.JumpPageHero} size="small" className={t4}>Get started</FlowCta>;
    $[6] = selectedOption;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <div className={t0}>{t1}<div className={t2}>{t3}{t5}</div></div>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}